import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Button from "../../../widgets/button";
import { Validation } from "../../../utils";
import { showToaster, toasterTypes } from "../../../widgets";
import { FieldItem, FIELD_TYPES } from "../../../widgets/fields";
import { CategoryService } from "../../../service/category";


type Props = {
  setAreaModel: (toggleState: boolean) => void,
  onSubmitSuccess: () => void,
  categoryId: string;
  editArea: {
    id: string;
    areaName: string
  } | null
  modal: boolean
}

const AddEditAreaModal = (props: Props) => {

  const [formState, setFormState] = useState({
    id: props?.editArea?.id ? props?.editArea.id : '',
    areaName: props?.editArea?.areaName ? props?.editArea.areaName : ''
  })

  useEffect(() => {
    if (props.editArea) {
      setFormState({
        id: props?.editArea?.id ? props?.editArea.id : '',
        areaName: props?.editArea?.areaName ? props?.editArea.areaName : ''
      })
    }

  }, [props?.editArea])

  const handleOnChange = (event: any) => {
    try {
      const { name, value } = event.currentTarget;
      setFormState({ ...formState, [name]: value });
    } catch (error) {
      console.log(error?.message);
    }
  };

  const onSubmit = () => {
    try {
      if (Validation.isTextRequired(formState.areaName, "Area name")) {
        return false;
      }

      const payload: { id?: string, name: string, state_id: string } = {
        name: formState.areaName,
        state_id: props.categoryId
      };

      if (formState.id) {
        payload.id = formState.id;
      }

      CategoryService.addAreas(payload).subscribe(
        (data: any) => {
          if (data.status && data.statusCode === 200) {
            props.onSubmitSuccess();
            deleteToggle();
            reset();
            showToaster(toasterTypes.SUCCESS, data.message);
          } else {
            showToaster(toasterTypes.ERROR, data.message);
          }
        },
        (error: any) => {
          console.log(error);
          showToaster(toasterTypes.ERROR, error.message);
        }
      );
    } catch (error) {
      console.log(error?.message);
    }
  };

  const deleteToggle = () => {
    props.setAreaModel(false)
  };

  const toggle = () => {
    if (props.modal === true) {
      reset();
    }

    props.setAreaModel(!props.modal)
  };

  const reset = () => {
    setFormState({ areaName: '', id: '' })
  };

  const closeBtn = (
    <button className="close" title="Close" onClick={toggle}>
      &times;
    </button>
  );

  return <>
    <Modal isOpen={props.modal} toggle={toggle}>
      <ModalHeader
        className="modal_Bg"
        close={closeBtn}
        toggle={toggle}
      >
        <div className="modal_title">
          {formState.id
            ? "Update Area"
            : "Create Area"}
        </div>
      </ModalHeader>
      <ModalBody>
        <FieldItem
          onChange={handleOnChange}
          label="Area Name "
          name="areaName"
          value={formState.areaName}
          placeholder="Area Name "
          type={FIELD_TYPES.TEXT}
          className="form-control required"
          required
        />
      </ModalBody>
      <ModalFooter>
        <Button
          label="Cancel"
          className="ml-2 btn btn-outline-secondary"
          onClick={toggle}
        />
        <Button
          label={formState.id ? "Update" : "Save"}
          className="ml-2 btn btn-theme-primary"
          onClick={onSubmit}
        />
      </ModalFooter>
    </Modal></>
}

export default AddEditAreaModal;